import type { Identifier } from "ra-core";
import { useState } from "react";

import { cn } from "@/lib/utils";

import { WhatsappThread } from "../whatsapp/WhatsappThread";
import { ChannelIcon } from "./ChannelIcon";
import { CHANNEL_LABEL, socialKey } from "./social";
import { useSocialInbox } from "./useSocial";

/**
 * The client's conversations on the sheet: WhatsApp, plus Instagram or
 * Messenger when they wrote there. One tab per channel.
 */
export const ClientConversations = ({
  contactId,
  phone,
  firstName,
}: {
  contactId: Identifier;
  phone?: string | null;
  firstName?: string | null;
}) => {
  const { threads } = useSocialInbox({ contact_id: contactId });
  const tabs = [
    { key: "wa", channel: "whatsapp" as const, threadId: null },
    ...threads.map((thread) => ({
      key: socialKey(thread),
      channel: thread.channel,
      threadId: thread.id,
    })),
  ];
  const [selected, setSelected] = useState("wa");
  const current = tabs.find((tab) => tab.key === selected) ?? tabs[0];

  return (
    <section className="flex flex-col gap-2">
      <div className="flex items-center gap-2">
        <h4 className="text-sm font-semibold">
          {tabs.length > 1 ? "Mensajes" : "WhatsApp"}
        </h4>
        {tabs.length > 1
          ? tabs.map((tab) => (
              <button
                key={tab.key}
                type="button"
                onClick={() => setSelected(tab.key)}
                className={cn(
                  "inline-flex items-center gap-1 rounded-full border px-2.5 py-0.5 text-xs",
                  current.key === tab.key
                    ? "border-neutral-900 bg-neutral-100 dark:border-lime-300 dark:bg-lime-950/40"
                    : "text-muted-foreground hover:bg-muted",
                )}
              >
                <ChannelIcon channel={tab.channel} />
                {CHANNEL_LABEL[tab.channel]}
              </button>
            ))
          : null}
      </div>
      <WhatsappThread
        key={current.key}
        channel={current.channel}
        contactId={contactId}
        threadId={current.threadId}
        phone={phone}
        firstName={firstName}
        className="h-96"
      />
    </section>
  );
};
